import React from 'react';


export interface SelectOption {
  label: string|JSX.Element,
  value: number,
  icone?: React.ReactNode
}

export const SelectItem = (option: SelectOption, { context }: any) => {
  return <SelectItemView option={option} />
}

interface SelectItemViewProps {
  option: SelectOption
}

export const SelectItemView: React.FC<SelectItemViewProps> = ({option}) => {
  const styleDiv = {
    display: 'flex',
    alignItems: 'center',
  }
  const styleText = {
    paddingLeft: option.icone? 8 : 0,
    paddingBottom: 0,
  }

  return (
    <div style={styleDiv}>
      {option.icone}
      <span style={styleText}>{option.label}</span>
    </div>
  );
};